import React, { useEffect, useState } from 'react';
import LoaderStyleOne from "../../components/LoaderStyleOne";
import { Box, Typography, Button, IconButton, TextField, Container, Divider, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { getData, postData } from "../../ServerRequest";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { styled } from '@mui/material/styles';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}));
function createData(code, reqQty, availQty) {
    return { code, reqQty, availQty };
}

// const rows = [
//     createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
//     createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
//     createData('Eclair', 262, 16.0, 24, 6.0),
//     createData('Cupcake', 305, 3.7, 67, 4.3),
//     createData('Gingerbread', 356, 16.0, 49, 3.9),
// ];

export default function EnquiryDetail() {
    const searchParams = new URLSearchParams(window.location.search);
    const bookingId = searchParams.get('booking_id');
    const [bookingData, setBookingData] = useState([]);
    const [buyerData, setBuyerData] = useState([]);
    const [bookingProductData, setBookingProductData] = useState([]);
    const [loading, setLoading] = useState(true);

    const filterBookingProductData = (bookingData) => {
        let bookingTableData = [];
        let codes = bookingData.ps_book_codes.split(',');
        let reqOty = bookingData.ps_book_qty.split(',');
        let availQty = bookingData.ps_book_avail_qty.split(',');
        let enquiryProducts = bookingData.enquiry_products ? bookingData.enquiry_products : [];
        let swchQty = bookingData.ps_book_swchqty ? bookingData.ps_book_swchqty.split(',') : [];
        // Parse comments array from string
        let comments = [];
        try {
            comments = JSON.parse(bookingData.ps_book_comments.replace(/'/g, '"'));
        } catch (e) {
            comments = [];
        }
    // ...messages parsing removed (was unused)...
        // Dummy data for new columns (replace with real data as needed)
        let yardage = bookingData.ps_book_yardage ? bookingData.ps_book_yardage.split(',') : [];
        let swatchUpdate = bookingData.ps_book_swatch_update ? bookingData.ps_book_swatch_update.split(',') : [];
        let fabricTesting = bookingData.ps_book_fabric_testing ? bookingData.ps_book_fabric_testing.split(',') : [];
        if (bookingData.ps_book_codes) {
            console.log("Enquiry Products:", enquiryProducts);
            
            bookingTableData = enquiryProducts.map((code, index) => {

                // Remove square brackets from available quantity if present
                let cleanAvailQty = availQty[index] ? availQty[index].replace(/\[|\]/g, '') : '';
                return {
                    ...createData(code.product_id, reqOty[index], cleanAvailQty),
                    swchQty: code.swatch_qty || '',
                    comment: comments[index] || '',
                    status: bookingData.ps_book_status || 0,
                    codeIndex: index,
                    yardage: code.yardage || '',
                    swatchUpdate: code.swatchUpdate || '',
                    fabricTesting: code.fabricTesting || '',
                };
            });
        }
        return bookingTableData;
    };

    useEffect(() => {
        async function getBookingData() {
            let resData = await getData('/api/buyer/booking?booking_id=' + bookingId);
            console.log(resData);
            let booking_data = resData['data']['bookings'][0];
            if (booking_data) {
                let bookingData = await filterBookingProductData(booking_data);
                
                if (bookingData) {
                    setBookingProductData(bookingData);
                }
            }
            let resBuyerData = await getData('/api/buyer?buyer_id=' + booking_data.ps_book_buyerid);
            
            let buyerDataRes = resBuyerData['data']['buyers'];
            
            
            if (buyerDataRes) {
                setBuyerData(buyerDataRes);
                
                
            }
            setBookingData(booking_data);
            setLoading(false);
        }
        getBookingData();
    }, []);

    return (
        <Box sx={{ width: '95%', paddingLeft: 3, mb:5, borderRadius: 0 }} style={{ fontFamily: 'Inter' }}>
            <Box sx={{ display: 'flex', bgcolor: '#f8f9fa', border: '2px solid #f4f3f6', justifyContent: 'space-between', alignItems: 'center', boxShadow: 0, p: 4, borderRadius: 0 }}>
                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: 300 }}>
                        <LoaderStyleOne />
                    </Box>
                ) : (
                    <>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant="body1" sx={{ ml: 2, color: "#000", fontFamily: "Inter", fontWeight: 700, fontSize: "17px", marginBottom: "4px", }}>
                                    Enquiry ID : <span style={{ fontWeight: 400, color: '#000' }}>{bookingData.ps_book_id}</span>
                                </Typography>
                            </Grid>
                            <Divider sx={{ mt: 2 }} />
                            <Grid item xs={4}>
                                <Typography variant="body1" sx={{ ml: 2, color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: "15px", marginBottom: "4px", }}>
                                    Buyer ID : <span style={{ fontWeight: 400, color: '#000' }}>{buyerData.ps_buyer}</span>
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" sx={{ ml: 2, color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: "15px", marginBottom: "4px", }}>
                                    Buyer Name : <span style={{ fontWeight: 400, color: '#000' }}>{buyerData.ps_buyer_name}</span>
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" sx={{ ml: 2, color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: "15px", marginBottom: "4px", }}>
                                    Buyer Email : <span style={{ fontWeight: 400, color: '#000' }}>{buyerData.ps_buyer_email}</span>
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" sx={{ ml: 2, color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: "15px", marginBottom: "4px", }}>
                                    Buyer Phone : <span style={{ fontWeight: 400, color: '#000' }}>{buyerData.ps_buyer_phone}</span>
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="body1" sx={{ ml: 2, color: "#424956", fontFamily: "Inter", fontWeight: 700, fontSize: "15px", marginBottom: "4px", }}>
                                    Buyer City : <span style={{ fontWeight: 400, color: '#000' }}>{buyerData.ps_buyer_city}</span>
                                </Typography>
                            </Grid>
                            <Divider sx={{ mt: 2 }} />
                            <Grid item xs={12}>
                                <TableContainer component={Paper} sx={{ borderRadius: 0, boxShadow: 0, border: '2px solid #f4f3f6' }}>
                                    <Table sx={{ minWidth: 550 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Product ID</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Requested Qty</TableCell>                                                
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Available Qty</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Swatch Qty</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Yardage</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Swatch Update No.</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Fabric Testing Report</TableCell>
                                                <TableCell align="center" sx={{ fontWeight: 600 }}>Comments</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {bookingProductData.map((row, idx) => (
                                                <TableRow
                                                    key={row.code}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell align="center" component="th" scope="row">
                                                        {row.code}
                                                    </TableCell>
                                                    <TableCell align="center">{row.reqQty}</TableCell>                                                    
                                                    <TableCell align="center">{row.availQty}</TableCell>
                                                    <TableCell align="center">{row.swchQty}</TableCell>
                                                    <TableCell align="center">{row.yardage}</TableCell>
                                                    <TableCell align="center">{row.swatchUpdate}</TableCell>
                                                    <TableCell align="center">
                                                        <FormControl size="small" fullWidth>
                                                            <Select
                                                                value={row.fabricTesting}
                                                                displayEmpty
                                                                inputProps={{ 'aria-label': 'Fabric Testing Report' }}
                                                                sx={{ minWidth: 120 }}
                                                            >
                                                                <MenuItem value=""><em>Select</em></MenuItem>
                                                                <MenuItem value="Report1">Report 1</MenuItem>
                                                                <MenuItem value="Report2">Report 2</MenuItem>
                                                                <MenuItem value="Report3">Report 3</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </TableCell>
                                                    <TableCell align="center">{row.comment}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>                        
                    </>
                )}
            </Box>
        </Box>
    );
}
